"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var authentication_1 = require("../authentication");
var reducer_1 = require("../components/languageSelector/redux/reducer");
var Reducer_1 = require("../components/layoutContent/Redux/Reducer");
var reducer_2 = require("../Services/Redux/reducer");
exports.ComponentEtaMapStateToProps = function (state) { return ({
    currentLang: state.reduxlanguage.language,
}); };
// add a way to get the store of the hosted web application
var applicationStore;
exports.getLibraryReducers = function () {
    return { reduxlanguage: reducer_1.languageReducer,
        layouHeader: Reducer_1.layoutHeaderReducer,
        authentication: authentication_1.authenticationReducer,
        globalErrors: reducer_2.errorsReducer
    };
};
// call attachStore on the web app just after the creation
exports.attachStore = function (store) {
    applicationStore = store;
};
exports.getStore = function () {
    return (applicationStore);
};
//# sourceMappingURL=index.js.map